import { decodeHexResponse } from '../_common/common.utils';
import VisitorPassTypes from './visitorPass.types';

interface VisitorPassState {
	createVisitorPassResponse: {
		status: string;
		message?: string;
		data?: any;
	} | null;
	allVisitorPassesData: {
		status: string;
		data?: Array<any>;
		message?: string;
	} | null;
	getVisitorPassData: {
		status: string;
		data?: any;
		message?: string;
	} | null;
	updateVisitorPassResponse: {
		status: string;
		message?: string;
		data?: any;
	} | null;
	deleteVisitorPassResponse: {
		status: string;
		message?: string;
	} | null;
}

const initialState: VisitorPassState = {
	createVisitorPassResponse: null,
	allVisitorPassesData: null,
	getVisitorPassData: null,
	updateVisitorPassResponse: null,
	deleteVisitorPassResponse: null,
};

const visitorPassReducer = (state = initialState, action: any): VisitorPassState => {
	switch (action.type) {
		// Create Visitor Pass
		case VisitorPassTypes.CREATE_VISITOR_PASS_START:
			return {
				...state,
				createVisitorPassResponse: null,
			};
		case VisitorPassTypes.CREATE_VISITOR_PASS_SUCCESS:
			return {
				...state,
				
				createVisitorPassResponse:decodeHexResponse(action.payload,"createVisitorPassKey")
			};
		case VisitorPassTypes.CREATE_VISITOR_PASS_FAILURE:
			return {
				...state,
				createVisitorPassResponse:decodeHexResponse(action.payload,"createVisitorPassKey")
			};
		case VisitorPassTypes.CREATE_VISITOR_PASS_RESPONSE_REST_START:
			return {
				...state,
				createVisitorPassResponse: null,
			};

		// Get All Visitor Passes
		case VisitorPassTypes.GET_ALL_VISITOR_PASSES_START:
			return {
				...state,
				allVisitorPassesData: null,
			};
		case VisitorPassTypes.GET_ALL_VISITOR_PASSES_SUCCESS:
			return {
				...state,
				allVisitorPassesData:decodeHexResponse(action.payload,"getAllVisitorPasseskey"),
			};
		case VisitorPassTypes.GET_ALL_VISITOR_PASSES_FAILURE:
			return {
				...state,
				allVisitorPassesData:decodeHexResponse(action.payload,"getAllVisitorPasseskey"),
			};
		case VisitorPassTypes.GET_ALL_VISITOR_PASSES_RESPONSE_REST_START:
			return {
				...state,
				allVisitorPassesData: null,
			};

		// Get Single Visitor Pass
		case VisitorPassTypes.GET_VISITOR_PASS_START:
			return {
				...state,
				getVisitorPassData: null,
			};
		case VisitorPassTypes.GET_VISITOR_PASS_SUCCESS:
			return {
				...state,
				getVisitorPassData:decodeHexResponse(action.payload,"getVisitorPasskey") ,
			};
		case VisitorPassTypes.GET_VISITOR_PASS_FAILURE:
			return {
				...state,
				getVisitorPassData:decodeHexResponse(action.payload,"getVisitorPasskey"),
			};
		case VisitorPassTypes.GET_VISITOR_PASS_RESPONSE_REST_START:
			return {
				...state,
				getVisitorPassData: null,
			};

		// Update Visitor Pass
		case VisitorPassTypes.UPDATE_VISITOR_PASS_START:
			return {
				...state,
				updateVisitorPassResponse: null,
			};
		case VisitorPassTypes.UPDATE_VISITOR_PASS_SUCCESS:
			return {
				...state,
				updateVisitorPassResponse: decodeHexResponse(action.payload,"updateVisitorPassKey"),
			};
		case VisitorPassTypes.UPDATE_VISITOR_PASS_FAILURE:
			return {
				...state,
				updateVisitorPassResponse: decodeHexResponse(action.payload,"updateVisitorPassKey"),
			};
		case VisitorPassTypes.UPDATE_VISITOR_PASS_RESPONSE_REST_START:
			return {
				...state,
				updateVisitorPassResponse: null,
			};

		// Delete Visitor Pass
		case VisitorPassTypes.DELETE_VISITOR_PASS_START:
			return {
				...state,
				deleteVisitorPassResponse: null,
			};
		case VisitorPassTypes.DELETE_VISITOR_PASS_SUCCESS:
			return {
				...state,
	
				deleteVisitorPassResponse: decodeHexResponse(action.payload,"deleteVisitorPassKey"),
			};
		case VisitorPassTypes.DELETE_VISITOR_PASS_FAILURE:
			return {
				...state,
				deleteVisitorPassResponse: decodeHexResponse(action.payload,"deleteVisitorPassKey"),
			};
		case VisitorPassTypes.DELETE_VISITOR_PASS_RESPONSE_REST_START:
			return {
				...state,
				deleteVisitorPassResponse: null,
			};

		default:
			return state;
	}
};

export default visitorPassReducer; 